import {
  Flex,
  IconButton,
  IconEditLine,
  IconTrashLine,
  Pill,
  Text,
  View,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useContext, useState } from "react";
import { Link } from "react-router";
import { ReflectionTemplateService } from "../../services/ReflectionTemplateService";
import { UserDetailContext } from "../../utils/Context";
import { Card } from "../Card";
import { ERROR, useNotification } from "../CustomHooks/NotificationProvider";
import { DialogYesNo } from "../DialogYesNo/DialogYesNo";

const ReflectionTemplateCard = ({ template, setTemplates, cycleTypes }) => {
  const { t } = useTranslation();
  const userDetails = useContext(UserDetailContext);
  const showNotification = useNotification();
  const [deleteModal, setDeleteModal] = useState(false);

  async function handleDelete() {
    try {
      await ReflectionTemplateService.deleteTemplate(template.id);
      setTemplates((prevTemplates) =>
        prevTemplates.filter((t) => t.id !== template.id)
      );
      setDeleteModal(false);
      showNotification(
        t("notifications.general.deleteSuccess", {
          obj: t("reflectionTemplates.reflectionTemplate"),
        })
      );
    } catch {
      showNotification(
        t("notifications.general.deleteError", {
          obj: t("reflectionTemplates.reflectionTemplate"),
        }),
        ERROR
      );
    }
  }

  return (
    <Card
      style={{
        color: "#0D323F",
        backgroundColor: "#F2F8FA",
        border: "1px solid #ccc",
        borderRadius: 10,
        padding: "10px 15px",
      }}
    >
      <Flex>
        <Flex.Item shouldGrow shouldShrink>
          <Text weight="bold">{template.name}</Text>
          <View as="div" margin="x-small 0 small 0">
            <Text color="brand">
              <Text weight="bold">
                {t("cyclesAndGoals.typeSelect.label")}:{" "}
              </Text>
              {
                cycleTypes.find((cycle) => cycle.id === template.cycle_type_id)
                  ?.label
              }
            </Text>
          </View>
          <Text color="brand">
            <Text weight="bold">{t("cyclesAndGoals.cycleType.duration")}</Text>{" "}
            <Pill color="info">{template.start_year.name}</Pill> -{" "}
            <Pill color="info">{template.end_year.name}</Pill>
          </Text>
          <View as="div" margin="x-small 0 0 0">
            <Text color="brand">
              <Text weight="bold">{t("global.departments")}: </Text>
            </Text>
            <Flex gap="small" display="inline-flex" wrap="wrap">
              {template.departments.map((d) => (
                <Flex.Item key={d.id}>
                  <Pill color="info">{d.name}</Pill>
                </Flex.Item>
              ))}
            </Flex>
          </View>
        </Flex.Item>
        {userDetails.name === template.author && (
          <Flex.Item margin="0 small 0 0">
            <Link
              to={{
                pathname: "/setup/reflection-templates/",
                search: `?mode=edit&id=${template.id}`,
              }}
            >
              <IconButton
                renderIcon={IconEditLine}
                screenReaderLabel={`${t("academicHierarchy.edit")} ${template.name}`}
              />
            </Link>
          </Flex.Item>
        )}
        {userDetails.name === template.author && (
          <Flex.Item>
            <IconButton
              renderIcon={IconTrashLine}
              screenReaderLabel={`${t("evidence.delete")} ${template.name}`}
              onClick={() => setDeleteModal(true)}
            />
          </Flex.Item>
        )}
      </Flex>
      <DialogYesNo
        message={t("templates.deleteConfirm")}
        openStatus={deleteModal}
        onClickNo={() => setDeleteModal(false)}
        onClickYes={handleDelete}
      />
    </Card>
  );
};

export default ReflectionTemplateCard;
